// extracted by mini-css-extract-plugin
export default {"container":"award_container__3rjKr","inner":"award_inner__2kcO0","isContainer":"award_isContainer__2wY63","award":"award_award__2MIrI"};